import React from 'react';
import { Box } from '../../../../primitives/Box/Box.es.js';

const NoResults = ({ children }) => /* @__PURE__ */ React.createElement(Box, {
  px: "md",
  py: "sm"
}, children);

export { NoResults };
//# sourceMappingURL=NoResults.es.js.map
